// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostAccessItem,
}                               from '../interfaces';

const getUserPostAccess = async ({
    test,
}: {
    test: boolean,
}): Promise<Map<string, IPostAccessItem> | null> => {
    const functions = getFunctions();
    const handleGetUserPostAccess = httpsCallable<
        Record<
            string,
            boolean
        >,
        {
            [k: string]: IPostAccessItem,
        } | null
    >(
        functions,
        'getUserPostAccess',
    );
    return handleGetUserPostAccess({
        test,
    }).then((result) => {
        if (result.data != null) {
            const postAccess: Map<string, IPostAccessItem> = new Map(Object.entries(result.data));
            return postAccess;
        }
        return null;
    }).catch((err) => {
        throw err;
    });
};

export default getUserPostAccess;
